/**
 * Can we actually tell WHERE a delivery address is?
 *
 * An address typed by hand carries no map pin (``lat: null`` — deliberate, see AddressPickerModal's
 * coordsConfirmed note), so the only thing that places it is its pincode matching one of the
 * tenant's zones. When the pincode isn't in any zone either (production, Sep 2026: a Wanaparthy
 * customer typed 509102 while the zone listed only 509103), the address is un-locatable: checkout
 * accepted the order anyway, and Navigate — with nothing to go on — sent the rider to a text-search
 * result in another city. The checkout page uses this to ask the customer to set their location
 * BEFORE placing the order, instead of accepting silently.
 *
 * Deliberately narrow, so nothing that works today starts prompting:
 *  - a real map pin (any coordinates)                          → fine, never prompt;
 *  - no pin but the pincode matches a zone                     → fine, the zone places it;
 *  - no pin, pincode matches nothing (zoneStatus.zone == null) → ask for the location;
 *  - the zone check itself failed (zoneStatus undefined/null)  → fine — never block ordering on a
 *    network hiccup; the backend keeps exactly its existing behaviour.
 * The address TEXT is never inspected, so local-language (Telugu/Hindi/…) addresses behave the
 * same as English ones.
 */
import { isRealCoord } from "./openMap";

export function hasRealCoords(addr) {
    return !!addr && isRealCoord(addr.lat) && isRealCoord(addr.lng);
}

export function needsLocationUpdate(addr, zoneStatus) {
    if (!addr || hasRealCoords(addr)) return false;
    if (!zoneStatus || typeof zoneStatus !== "object") return false;   // check unavailable → fail open
    return !zoneStatus.zone;
}
